<template>
  <div v-if="can('update', 'payroll_info')">
    <b v-if="employeeState=='showing'"><p class="text-danger" v-if="edited">Los cambios no han sido guardados. <a href="#" @click.prevent="saveChanges">Guardar.</a></p></b>
    <b-button class="float-right" @click="resetNewQsPaymentRulesGroups" v-if="edited == true" >Descartar cambios</b-button>
    <b-table responsive v-if="qsPaymentRulesGroups.length>0" :fields="qsPaymentRulesGroupFields" :items="qsPaymentRulesGroups" hover striped></b-table>
    <b-button variant="success" v-if="state=='show'" @click="create">Agregar regla de cobro de parejas</b-button>
    <div v-if="state=='creating'">
      <b-form-group horizontal label="Regla">
        <b-form-select :options="qsPaymentRulesGroupOptions" :value="rule" @input="updateQsPaymentRulesGroup(['rule', $event])"></b-form-select>
      </b-form-group>
      <b-form-group horizontal label="Fecha a partir de la cual pertenece a este grupo">
        <b-form-input type="date" @input="updateQsPaymentRulesGroup(['effective_date', $event])" :value="effective_date"></b-form-input>
      </b-form-group>
      <b-button variant="success" @click="addIfValid">Agregar</b-button>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import { Validation } from '../../utils';
export default{
  props: {
    payrollConfig: {
      required: true,
      type: Object
    }
  },
  data (){
    return {
      qsPaymentRulesGroupFields: {
        rule: {
          label: 'Regla',
        },
        effective_date: {
          label: 'A partir del',
        }
      }
    }
  },
  methods: {
    can: (action, resource)=>{
      if(permissions===null) return false
      if(typeof(permissions[resource])==='undefined') return false
      return permissions[resource].includes(action)
    },

    ...mapActions(['resetNewQsPaymentRulesGroups', 'saveChanges']),
    ...mapMutations({
      updateQsPaymentRulesGroup: 'updateNewQsPaymentRulesGroupAttribute',
      create: 'creatingQsPaymentRulesGroup'
    }),
    addIfValid (){
      var validation = this.valid()
      if(validation.valid)
        this.$store.dispatch('addQsPaymentRulesGroup', {
          payroll_config_id: this.payrollConfig.id,
          rule: this.rule,
          effective_date: this.effective_date
        });
      else
        this.$store.dispatch('displayError',validation.messageBag);
    },
    valid (){
      var validator = new Validation();
      validator.rule(
        this.effective_date!='', 'Debe haber una fecha')
      validator.rule(
        this.rule!==null, 'Selecciona una regla')
      return validator.validate()
    }
  },
  computed: {
    ...mapGetters({
      edited: 'qsPaymentRulesGroupEdited'
    }),
    ...mapState({
      employeeState: state=>state.employeeManager.state,
      // qsPaymentRulesGroups: state=>state.employeeManager.employee.qsPaymentRulesGroups,
      state: state=>state.employeeManager.qsPaymentRulesGroupState,
      rule: state=>state.employeeManager.newQsPaymentRulesGroup.rule,
      effective_date: state=>state.employeeManager.newQsPaymentRulesGroup.effective_date,
      availableGroups: state=>state.employeeManager.qsPaymentRulesGroups
    }),
    qsPaymentRulesGroupOptions(){
      return this.availableGroups.map(d=>{
        return {
          value: d.id, text: d.name
        }
      }).concat([{value: null, text:'--Seleccionar regla de parejas--'}])
    },
    qsPaymentRulesGroups() {
      return this.payrollConfig.qsPaymentRulesGroups;
    }
  }
  
}
</script>


